function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 10V8H5.09C6.47 5.61 9.05 4 12 4C15.72 4 18.85 6.56 19.74 10H21.8C20.87 5.44 16.84 2 12 2C8.73 2 5.82 3.58 4 6.01V4H2V10H8Z",
  fill: "black",
  fillOpacity: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8334 10.5099C11.0603 9.81899 9.94734 9.64638 9.05389 10.1622C7.92083 10.8164 7.56856 12.3328 8.26816 13.5445C8.96777 14.7563 10.4572 15.2094 11.5902 14.5553C12.4837 14.0394 12.8906 12.9893 12.6789 11.9743L14.1679 11.1145L15.0134 12.5789L16.3826 11.7884L15.5372 10.324L16.2218 9.92873L15.3764 8.46438L11.8334 10.5099ZM10.7448 13.0909C10.3682 13.3083 9.86992 13.1567 9.63743 12.754C9.40493 12.3513 9.52279 11.844 9.89934 11.6266C10.2759 11.4092 10.7742 11.5608 11.0067 11.9635C11.2392 12.3662 11.1213 12.8735 10.7448 13.0909Z",
  fill: "black",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 14V16H18.91C17.53 18.39 14.95 20 12 20C8.27995 20 5.14995 17.44 4.25995 14H2.19995C3.12995 18.56 7.15995 22 12 22C15.27 22 18.18 20.42 20 17.99V20H22V14H16Z",
  fill: "black",
  fillOpacity: 0.6
});

function SvgRefreshIconWithKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIconWithKey);
export default __webpack_public_path__ + "static/media/refresh-icon-with-key.5fa0183c.svg";
export { ForwardRef as ReactComponent };